var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{staticStyle:{"height":"100%"},attrs:{"src":_vm.iurl,"name":_vm.iname,"width":"100%","frameborder":"0","marginheight":"0","marginwidth":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }